"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@wwnds/react");

require("./Droppable.css");

var Droppable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Droppable, _React$Component);

  var _super = (0, _createSuper2.default)(Droppable);

  function Droppable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Droppable);
    _this = _super.call(this, props);
    _this.state = {
      hovered: false,
      hadChildren: props.children.length !== 0
    };
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(Droppable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevprops.mouseX !== this.props.mouseX || prevprops.mouseY !== this.props.mouseY) {
        if (this.ref.current && this.props.dragElement) {
          var node = this.ref.current.getBoundingClientRect();

          if (node.left <= this.props.mouseX && // Left
          node.right >= this.props.mouseX && // Right
          node.top + window.scrollY <= this.props.mouseY && // Top
          node.bottom + window.scrollY >= this.props.mouseY) {
            if (!this.state.hovered) this.props.onHover();
            this.setState({
              hovered: true
            });
          } else {
            if (this.state.hovered && this.props.hovered) this.props.onEndHover();
            this.setState({
              hovered: false
            });
          }
        } else {
          if (this.state.hovered && this.props.hovered) this.props.onEndHover();
          this.setState({
            hovered: false
          });
        }
      }

      if (this.props.children.length !== 0 && !this.state.hadChildren) this.setState({
        hadChildren: true
      });
    }
  }, {
    key: "generateDropdown",
    value: function generateDropdown() {
      var _this2 = this;

      var dropdown = [];
      this.props.choices.forEach(function (choice) {
        if (_this2.props.unplacedChoices && !_this2.props.unplacedChoices.includes(choice.choiceIndex)) {
          return;
        }

        var dropdownContent = choice.accessible ? choice.accessible : choice.content;
        dropdown.push( /*#__PURE__*/_react.default.createElement(_react2.Dropdown.Option, {
          key: choice.choiceIndex,
          value: choice.choiceIndex,
          eventKey: choice.choiceIndex,
          "aria-label": choice.accessibleLabel ? choice.accessibleLabel : ""
        }, dropdownContent));
      });
      return !(!this.props.submit && this.props.children.length) && /*#__PURE__*/_react.default.createElement(_react2.Dropdown, {
        className: "accessible-droppable",
        label: this.props.hotspot && this.props.hotspot.label,
        disabled: !this.props.submit && this.props.children.length,
        onChange: function onChange(obj) {
          console.log("onSelect", obj);

          var ids = _this2.props.choices[obj.value].sourceArray.split(";");

          _this2.props.updateHotspotsAfterDrop(ids, _this2.props.accessibleLocation);
        }
      }, dropdown);
      /*<select className="accessible-droppable" aria-label=""  value="" onChange={(e)=>{
          let ids= this.props.choices[parseInt(e.target.selectedOptions[0].getAttribute('choiceindex'))].sourceArray.split(";")
          this.props.updateHotspotsAfterDrop(ids, this.props.accessibleLocation)}
        }>
          {dropdown}
        </select>*/
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        className: "droppable" + (this.props.active ? " active " : " ") + (this.props.hovered ? " hovered " : " ") + (!this.props.completed ? "wordbank-color " : " ") + (this.props.className || ""),
        style: this.props.style
      }, this.props.hotspotLabel && /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, " ", this.props.hotspotLabel, " "), this.props.className !== "wordbank" && this.generateDropdown(), /*#__PURE__*/_react.default.createElement("div", {
        className: "inner"
      }, this.props.children));
    }
  }]);
  return Droppable;
}(_react.default.Component);

var _default = Droppable;
exports.default = _default;